import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-association',
  templateUrl: './company-association.component.html',
  styleUrls: ['./company-association.component.css']
})
export class CompanyAssociationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
